<div [ngClass]="isMenuDisabled ? 'toolbar-disabled' : null"></div>
<div
  class="toolbar-container"
  [ngStyle]="{ 'background-color': navbarSettings && navbarSettings.backgroundColor ? navbarSettings.backgroundColor : '' }"
>
  <div class="left-wrapper">
    @if (isAuthenticated && navbarSettings?.settingAllowUseCases) {
      <button class="usecases-button" color="primary" [disabled]="isMenuDisabled" mat-flat-button (click)="goToUsecases()">
        {{ 'label_use_cases' | translate }}
      </button>
    }
    @if (isAuthenticated || isTenantAdminAuthenticated) {
      <app-global-date-grid-filter-panel [isDisabled]="isMenuDisabled"></app-global-date-grid-filter-panel>
    }
    @if (isAuthenticated) {
      <global-search-bar [isDisabled]="isMenuDisabled"></global-search-bar>
    }
  </div>

  <div class="right-wrapper">
    @if (notificationCount.countTaricsEntitlement && notificationCount.countTaricsEntitlement.length > 0) {
      <app-tarics-send-entitlements
        [taricsCount]="notificationCount.countTaricsEntitlement"
        [isDisabled]="isMenuDisabled"
      ></app-tarics-send-entitlements>
    }
    @if (isAuthenticated && navbarSettings?.settingInboxEnabled && authUser?.adminrights) {
      <div class="notification-container">
        <button
          class="notification-button"
          color="primary"
          [disabled]="isMenuDisabled"
          [matBadge]="notificationCount.countEmail > 0 ? (notificationCount.countEmail < 100 ? notificationCount.countEmail : '99+') : null"
          matBadgeColor="warn"
          matBadgeSize="medium"
          [matBadgeOverlap]="notificationCount.countEmail > 0"
          mat-icon-button
          (click)="goToIncomingMails()"
          [attr.aria-label]="'accessibility_label_navbar_incoming_email' | translate: { value: notificationCount.countEmail }"
        >
          <mat-icon>email</mat-icon>
        </button>
      </div>
    }
    @if (isAuthenticated) {
      <div class="notification-container">
        <button
          class="notification-button"
          color="primary"
          [disabled]="isMenuDisabled"
          [matBadge]="
            notificationCount.countNotification > 0
              ? notificationCount.countNotification < 100
                ? notificationCount.countNotification
                : '99+'
              : null
          "
          matBadgeColor="warn"
          matBadgeSize="medium"
          [matBadgeOverlap]="notificationCount.countNotification > 0"
          mat-icon-button
          (click)="goToNotifications()"
          [attr.aria-label]="'accessibility_label_navbar_notification' | translate: { value: notificationCount.countEmail }"
        >
          <mat-icon>notifications</mat-icon>
        </button>
      </div>
    }
    @if (isTenantAdminAuthenticated && isErrorOccurred) {
      <div class="error-warning-container">
        @if (!isExceptionErrorFileLoading) {
          <button
            class="spreadsheet-button"
            color="warn"
            mat-icon-button
            (click)="loadExceptionErrorFile()"
            [disabled]="isMenuDisabled"
            [attr.aria-label]="'accessibility_label_spreadsheet_button' | translate"
          >
            <mat-icon>warning</mat-icon>
          </button>
        } @else {
          <div class="spinner-with-icon-container">
            <mat-spinner diameter="24"></mat-spinner>
            <mat-icon color="warn">warning</mat-icon>
          </div>
        }
      </div>
    }
    <div class="actions-wrapper">
      @if (isAuthenticated || isTenantAdminAuthenticated) {
        <div class="logged-user" [matMenuTriggerFor]="isMenuDisabled ? null : profileMenu" [ngClass]="isMenuDisabled ? 'disabled' : ''">
          @if (navbarSettings && navbarSettings.tenantImage) {
            <img class="tenant-image" [src]="transform(navbarSettings.tenantImage)" [alt]="'accessibility_alt_tenant_img' | translate" />
          }
          @if (navbarSettings && !navbarSettings.tenantImage && navbarSettings.description) {
            <span class="tenant-name">{{ navbarSettings.description }}</span>
          }
          @if (navbarSettings && !navbarSettings.tenantImage && !navbarSettings.description) {
            <div class="user-image-wrapper">
              <app-preload-image
                class="user-image"
                [ratio]="{ w: 1, h: 1 }"
                [src]="'../../../../assets/imgs/photo_placeholder.jpg'"
                [alt]="'accessibility_alt_standard_profile_img' | translate"
                title="profile image"
              ></app-preload-image>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<mat-menu class="profile-menu" #profileMenu="matMenu" xPosition="before" overlapTrigger="false">
  @if (isAuthenticated || isTenantAdminAuthenticated) {
    <div mat-menu-item [disableRipple]="true" class="username">{{ authUser.fullname }}</div>
    <mat-divider></mat-divider>
  }
  @if (authUser && navbarSettings?.viewAsUserEnabled && !isTenantAdminAuthenticated) {
    <button mat-menu-item (click)="viewAsUser()">
      {{ 'topnavbar_menu_viewasuser' | translate }}
    </button>
  }
  @if (!isTenantAdminAuthenticated) {
    <button mat-menu-item routerLink="/pages/profile/settings">
      {{ 'topnavbar_menu_profile' | translate }}
    </button>
  }
  @if (authUser && !isTenantAdminAuthenticated) {
    <button mat-menu-item (click)="helpOverlay()">
      {{ 'topnavbar_menu_help' | translate }}
    </button>
  }
  @if (releasenotesSettings?.settingReleaseNotesEnabled && !isTenantAdminAuthenticated) {
    <button mat-menu-item routerLink="/pages/releasenotes">
      {{ 'topnavbar_menu_release_notes' | translate }}
    </button>
  }
  @if (authUser && !isTenantAdminAuthenticated) {
    <button mat-menu-item (click)="configurationOverlay()">
      {{ 'topnavbar_menu_configuration' | translate }}
    </button>
  }
  @if (authUser && !isTenantAdminAuthenticated) {
    <button mat-menu-item routerLink="/pages/system-errors">
      {{ 'topnavbar_menu_systemerrors' | translate }}
    </button>
  }
  @if (authUser && !isTenantAdminAuthenticated && navbarSettings?.settingSupportEmailAddress) {
    <button mat-menu-item (click)="contactUs()">
      {{ 'topnavbar_menu_contact_us' | translate }}
    </button>
  }
  <button mat-menu-item (click)="logout()">
    {{ 'topnavbar_menu_logout' | translate }}
  </button>
</mat-menu>
